var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterWaveEdited = function SvgFooterWaveEdited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 145"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "M1440 0H0v145h1440z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "M0 0v122.897C566.393 44.26 1000.2-69 1440 79.5V0z"
  })));
};
export default SvgFooterWaveEdited;